import { logger } from 'services/logger'

// Third-party snippets (Braze, Usercentrics) insert text nodes into <head>, and React 19's
// positional head hydration aborts on any unexpected text node → full-tree hydration failure.
// Direct text children of <head> are always inert (the parser reparents visible text into
// <body>), so removing them is safe. Non-whitespace removals are logged to identify the injector.

function removeTextNode(node: Text) {
  const text = node.textContent?.trim()
  if (text) {
    logger.info('Removed non-whitespace text node from <head>', {
      text: text.slice(0, 200),
    })
  }
  node.remove()
}

// One initial sweep isn't enough: hydration renders concurrently (it yields), so a text
// node can land mid-hydration. The observer keeps scrubbing, and stays on for the page's
// lifetime rather than tying teardown to hydration completion.
export function scrubHeadTextNodes() {
  for (const node of [...document.head.childNodes]) {
    if (node instanceof Text) {
      removeTextNode(node)
    }
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Text) {
          removeTextNode(node)
        }
      }
    }
  }).observe(document.head, { childList: true })
}
